import * as yup from "yup";

export const SecurityQuestionsScreenValidationSchema = yup.object().shape({
  questionOne: yup.string().required("Question is required"),

  questionTwo: yup
    .string()
    .required("Question is required")
    .test(
      "unique-question-two",
      "Please choose a different question",
      function (value) {
        const { questionOne } = this.parent;
        return value !== questionOne;
      },
    ),

  questionThree: yup
    .string()
    .required("Question is required")
    .test(
      "unique-question-three",
      "Please choose a different question",
      function (value) {
        const { questionOne, questionTwo } = this.parent;
        return value !== questionOne && value !== questionTwo;
      },
    ),

  answerOne: yup.string().min(3, "Minimum 3 characters").required("Answer is required"),
  answerTwo: yup.string().min(3, "Minimum 3 characters").required("Answer is required"),
  answerThree: yup.string().min(3, "Minimum 3 characters").required("Answer is required"),
});
